import { FvBoxAnchor, FvBoxVersion } from 'src/models/anchor-and-version/fv-box.model';
import { createBaseAnchor, createBaseVersion } from './base.factory';
import { AddressAnchor } from 'src/models/anchor-and-version/address.model';
import { FvBoxPortDataRelationAnchor } from 'src/models/anchor-and-version/fv-box-port-data-relation.model';
import { GatewayAnchor } from 'src/models/anchor-and-version/gateway.model';

export function createFvBoxAnchor(
    aParams: {
        // Base
        logText: string;
        sourceAeBoxAnchorKey: number;
        targetAeBoxAnchorKey: number;
        sourceAddressAnchorKey: number | null;
        targetAddressAnchorKey: number | null;
        // Specific
        fvBoxPortDataRelationAnchors?: FvBoxPortDataRelationAnchor[];
        gatewayAnchors?: GatewayAnchor[];
        targetAddressAnchor?: AddressAnchor;
        sourceAddressAnchor?: AddressAnchor;
    },
    vParams: {
        // Base
        comment: string;
        logText: string;
        name: string;
        // Specific
        x: number;
        y: number;
        z: number;
        height: number;
        width: number;
    }
): FvBoxAnchor {
    const version = createFvBoxVersion({ ...vParams, anchorKey: 0, changeRequestKey: 1 });
    const anchor: FvBoxAnchor = {
        ...createBaseAnchor(aParams),
        sourceAeBoxAnchorKey: aParams.sourceAeBoxAnchorKey,
        targetAeBoxAnchorKey: aParams.targetAeBoxAnchorKey,
        sourceAddressAnchorKey: aParams.sourceAddressAnchorKey,
        targetAddressAnchorKey: aParams.targetAddressAnchorKey,
        gatewayAnchors: aParams.gatewayAnchors,
        fvBoxPortDataRelationAnchors: aParams.fvBoxPortDataRelationAnchors,
        targetAddressAnchor: aParams.targetAddressAnchor,
        sourceAddressAnchor: aParams.sourceAddressAnchor,
        displayName: null,
        allVersions: [version],
        validVersion: version,
    };

    return anchor;
}

export function createFvBoxVersion(params: {
    // Base
    anchorKey: number;
    changeRequestKey: number;
    comment: string;
    logText: string;
    name: string;
    // Specific
    x: number;
    y: number;
    z: number;
    height: number;
    width: number;
}): FvBoxVersion {
    const baseVersion = createBaseVersion(params);
    const version: FvBoxVersion = {
        ...baseVersion,
        x: params.x,
        y: params.y,
        z: params.z,
        height: params.height,
        width: params.width,
        name: params.name,
    };

    return version;
}
